import type { Mission } from '../missions.ts'

export const hud: Mission = {
  id: "hud",
  name: "U.S. Department of Housing and Urban Development",
  short: "HUD",
  call: "Housing",
  kind: "department",
  url: "https://www.hud.gov/",
  established: 1965,
  palette: {
    primary: "#163667",
    secondary: "#0b89d5",
    accent: "#128654",
  },
  colorSource: {
    kind: "site",
    url: "https://www.hud.gov/",
  },
  motif: "building",
  mission: {
    text: "Fostering strong communities that support quality, affordable homeownership opportunities, promoting economic development & self-sufficiency for all Americans.",
    url: "https://www.hud.gov/sites/dfiles/CFO/documents/FY2026HUDAnnualPerformancePlan.pdf",
  },
  fact: {
    text: "Robert C. Weaver became the first HUD Secretary on January 18, 1966.",
    url: "https://www.hud.gov/aboutus/history",
  },
  seal: {
    file: "public/seals/hud.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Housing_and_Urban_Development.svg",
  },
  identifier: {
    about: "https://www.hud.gov/aboutus",
    accessibility: "https://www.hud.gov/accessibility",
    foia: "https://www.hud.gov/foia",
    noFear: "https://www.hud.gov/no-fear-act",
    oig: "https://www.hudoig.gov/",
    performance: "https://www.hud.gov/stat/cfo/app-fy26",
    privacy: "https://www.hud.gov/aboutus/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/hud-weaver-facade.jpg",
        small: "/media/hud-weaver-facade-sm.jpg",
        alt: "The curved concrete facade of the Robert C. Weaver Federal Building, a grid of deep-set windows, with the department's name on a central pier.",
        title: "Robert C. Weaver Federal Building, HUD headquarters, Washington, D.C.",
        creator: "U.S. Department of Housing and Urban Development",
        source: "https://commons.wikimedia.org/wiki/File:Robert_C._Weaver_Federal_Building_-_51668526505.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/hud-weaver-plaza.jpg",
        small: "/media/hud-weaver-plaza-sm.jpg",
        alt: "A round concrete canopy on the plaza in front of the gridded facade of the Robert C. Weaver Federal Building.",
        title: "Robert C. Weaver Federal Building plaza, Washington, D.C.",
        creator: "U.S. Department of Housing and Urban Development",
        source: "https://commons.wikimedia.org/wiki/File:Robert_C._Weaver_Federal_Building_-_51666849852.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
